// extracted by mini-css-extract-plugin
module.exports = {"h1":"Typography_h1__3LQ-5","h2":"Typography_h2__3PKoj","h3":"Typography_h3__1ujAt","p":"Typography_p__2NQC4","span":"Typography_span__3xgI3"};